import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";

// Send the browser to a Stripe-hosted page (onboarding, checkout, billing portal) returned by our API.
export async function goToStripe(path, body) {
  try {
    const { data } = await api.post(path, body);
    window.location.assign(data.url);
  } catch (e) {
    toast.error(errMsg(e));
  }
}

export const Section = ({ title, subtitle, icon: Icon, children, testid }) => (
  <section className="rounded-3xl border bg-white p-6 sm:p-8" data-testid={testid}>
    <div className="mb-5 flex items-start gap-3">
      {Icon && <span className="rounded-2xl bg-teal-50 p-2.5 text-primary"><Icon className="h-5 w-5" /></span>}
      <div>
        <h2 className="text-lg font-semibold">{title}</h2>
        {subtitle && <p className="text-sm text-stone-600">{subtitle}</p>}
      </div>
    </div>
    {children}
  </section>
);

export const ErrorNote = ({ error, testid }) => (
  <p className="flex items-start gap-2 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900" data-testid={testid}>
    <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
    <span>{errMsg(error)}</span>
  </p>
);

export const Pill = ({ ok, children, testid }) => (
  <span data-testid={testid} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${ok ? "border-emerald-200 bg-emerald-50 text-emerald-800" : "border-amber-200 bg-amber-50 text-amber-800"}`}>
    {children}
  </span>
);

export const cents = (amount, currency = "usd") =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: currency.toUpperCase() }).format((amount || 0) / 100);
